import { render, staticRenderFns } from "./UserProjects.vue?vue&type=template&id=b4ad1008&"
import script from "./UserProjects.vue?vue&type=script&lang=js&"
export * from "./UserProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports